import * as React from 'react';
import { biLogger } from '../../../bi';
import s from '../modals.scss';
import { Modal, MessageBoxMarketerialLayout } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var SwitchToEditorModal = composer()
    .withTranslation()
    .withMarketplaceStore()
    .compose(function (_a) {
    var t = _a.t, appId = _a.appId, msid = _a.msid, marketplaceStore = _a.marketplaceStore, appName = _a.appName, appIcon = _a.appIcon;
    var handleClose = function () {
        // tslint:disable-next-line: no-floating-promises
        biLogger.appMarketCloseDialogBoxOfUpgradeWixX({
            app_id: appId,
            msid: msid,
        });
        marketplaceStore.closeAllModals();
    };
    var handleSwitch = function () {
        window.open("https://support.wix.com/en/article/adi-moving-from-adi-to-the-editor");
    };
    // tslint:disable-next-line: no-floating-promises
    biLogger.appMarketUpgradeSiteConnectDomainDialogBox({
        appId: appId,
        msid: msid,
        stepName: 'switch_to_editor',
    });
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxMarketerialLayout, { title: React.createElement(React.Fragment, null,
                React.createElement("img", { className: s.appIcon, src: appIcon }),
                React.createElement("div", null, t('modals-switchToEditor-header', { appName: appName }))), content: t('modals-switchToEditor-content'), theme: "white", primaryButtonLabel: t('modals-switchToEditor-cta'), onClose: function () { return handleClose(); }, onPrimaryButtonClick: function () { return handleSwitch(); }, primaryButtonTheme: "blue", secondaryButtonLabel: t('modals-switchToEditor-back'), onSecondaryButtonClick: function () { return handleClose(); } })));
});
//# sourceMappingURL=switch-to-editor-modal.js.map